import React from "react"
import ZdqConnectorStatus from "../../components/ZdqConnectorStatus"
import { BIGQUERY } from "../../Constants"

function ZdqBigQueryConnectorStatus() {
  return <ZdqConnectorStatus vendor={BIGQUERY}></ZdqConnectorStatus>
}

export default ZdqBigQueryConnectorStatus